export var TurnkeyProvider;
(function (TurnkeyProvider) {
    TurnkeyProvider["Email"] = "email";
    TurnkeyProvider["Google"] = "google";
    TurnkeyProvider["Apple"] = "apple";
})(TurnkeyProvider || (TurnkeyProvider = {}));
